import { render, staticRenderFns } from "./ReceiveNew_AddItemPO_List.vue?vue&type=template&id=2bc538a2&"
import script from "./ReceiveNew_AddItemPO_List.vue?vue&type=script&lang=js&"
export * from "./ReceiveNew_AddItemPO_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports